export const handleColorStatusUtil = (status_type: string) => {
  if (status_type === "draft") {
    return "default";
  } else if (status_type === "wait") {
    return "warning";
  } else if (status_type === "approve first") {
    return "info";
  } else if (status_type === "not approve first") {
    return "error";
  } else if (status_type === "approve second") {
    return "info";
  } else if (status_type === "not approve second") {
    return "error";
  } else if (status_type === "approve third") {
    return "success";
  } else if (status_type === "not approve third") {
    return "error";
  } else {
    return "warning";
  }
};

export const handleTextStatusUtil = (status_type: string) => {
  if (status_type === "draft") {
    return "Draft";
  } else if (status_type === "wait") {
    return "รอหัวหน้าตรวจสอบ";
  } else if (status_type === "approve first") {
    return "ผ่านการตรวจสอบจากหัวหน้า";
  } else if (status_type === "not approve first") {
    return "ไม่ผ่านการตรวจสอบจากหัวหน้า";
  } else if (status_type === "approve second") {
    return "ผ่านการตรวจสอบจากเจ้าหน้าที่";
  } else if (status_type === "not approve second") {
    return "ไม่ผ่านการตรวจสอบจากเจ้าหน้าที่";
  } else if (status_type === "approve third") {
    return "คำร้องได้รับการอนุมัติ";
  } else if (status_type === "not approve third") {
    return "คำร้องไม่ได้รับการอนุมัติ";
  } else {
    return "";
  }
};

export const allStatusLeaveOnline = () => {
  return [
    {
      id: "all",
      name: "สถานะทังหมด",
    },
    {
      id: "draft",
      name: "Draft",
    },
    {
      id: "wait",
      name: "รอหัวหน้าตรวจสอบ",
    },
    {
      id: "approve first",
      name: "ผ่านการตรวจสอบจากหัวหน้า",
    },
    {
      id: "not approve first",
      name: "ไม่ผ่านการตรวจสอบจากหัวหน้า",
    },
    {
      id: "approve second",
      name: "ผ่านการตรวจสอบจากเจ้าหน้าที่",
    },
    {
      id: "not approve second",
      name: "ไม่ผ่านการตรวจสอบจากเจ้าหน้าที่",
    },
    {
      id: "approve third",
      name: "คำร้องได้รับการอนุมัติ",
    },
    {
      id: "not approve third",
      name: "คำร้องไม่ได้รับการอนุมัติ",
    },
  ];
};

export const handleColorStatusUtilForApprove = (status_type: string) => {
  if (status_type === "draft") {
    return "default";
  } else if (status_type === "wait") {
    return "warning";
  } else if (status_type === "approve first") {
    return "info";
  } else if (status_type === "not approve first") {
    return "error";
  } else if (status_type === "approve second") {
    return "info";
  } else if (status_type === "not approve second") {
    return "error";
  } else if (status_type === "approve third") {
    return "success";
  } else if (status_type === "not approve third") {
    return "error";
  } else {
    return "warning";
  }
};

export const handleTextStatusUtilForApprove = (status_type: string) => {
  if (status_type === "draft") {
    return "Draft";
  } else if (status_type === "wait") {
    return "รอหัวหน้าตรวจสอบ";
  } else if (status_type === "approve first") {
    return "รอเจ้าหน้าที่ตรวจสอบ";
  } else if (status_type === "not approve first") {
    return "ไม่ผ่านการตรวจสอบจากหัวหน้า";
  } else if (status_type === "approve second") {
    return "รอผู้มีอำนาจอนุมัติพิจารณา";
  } else if (status_type === "not approve second") {
    return "ไม่ผ่านการตรวจสอบจากเจ้าหน้าที่";
  } else if (status_type === "approve third") {
    return "คำร้องได้รับการอนุมัติ";
  } else if (status_type === "not approve third") {
    return "คำร้องไม่ได้รับการอนุมัติ";
  } else {
    return "";
  }
};

export const allStatusLeaveOnlineForApprove = () => {
  return [
    {
      id: "all",
      name: "ทังหมด",
    },
    {
      id: "draft",
      name: "Draft",
    },
    {
      id: "wait",
      name: "รอหัวหน้าตรวจสอบ",
    },
    {
      id: "approve first",
      name: "รอเจ้าหน้าที่ตรวจสอบ",
    },
    {
      id: "not approve first",
      name: "ไม่ผ่านการตรวจสอบจากหัวหน้า",
    },
    {
      id: "approve second",
      name: "รอผู้มีอำนาจอนุมัติพิจารณา",
    },
    {
      id: "not approve second",
      name: "ไม่ผ่านการตรวจสอบจากเจ้าหน้าที่",
    },
    {
      id: "approve third",
      name: "คำร้องได้รับการอนุมัติ",
    },
    {
      id: "not approve third",
      name: "คำร้องไม่ได้รับการอนุมัติ",
    },
  ];
};
